export default {
  subject: (enhancedLease) => `Renewal Invitation`,
  body: (enhancedLease) => `
  <p><em>Dear ${enhancedLease.tenantNames}:</em></p>

  <p>Hopely you enjoy the house at ${enhancedLease.showStreetAddress}.</p>

  <p>However, your contract of the rental will end at ${enhancedLease.checkout_date}.  It is a time for you to decide if you
  are likely to stay at the house or you will move out at that time.</p>

  <p>If you decide to continue the rental, please reply this email/message by a message like 'Yes, I am happy to continue the rental.',
  and we will contact with you and the houselord for a negotiation.  We will need to sign a new contract.</p>

  <p>Or, if you decide to end the rental on time, please also reply this email/messge by a message like 'No, I will move out on time',
  and then we can do some preparation so that the rental can be ended on time.</p>

  <p>Please reply to this email/message and tell me your decision.  Looking forward to discuss it with you very soon.</p>

  <p>Have a good day!</p>

<p>Your tenant agant,</p>
<p>Unity Property Management</p>
  `,
}
